<template>
  <div>
    <template v-if='statusGeral !== ""'>
      <RF-Status :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
    </template>

    <div v-else-if='statusGeral === ""' class="cfg-contador-cadastro">
      <table>
        <template v-if="[ '', null, undefined ].indexOf(cpntCadastro.contador) === -1 && [ '', null, undefined ].indexOf(cpntCadastro.contador.clu) === -1">
          <tr>  
            <td class="cadastro">
              <!-- SETA O CADASTRO DO CONTADOR -->
              <RF-Visualizar-Dados-Cadastro 
                :cpntId="cpntCadastro.contador.clu"
                :cpntDados="cpntCadastro.contador"
                :cpntTipo="'licenca'"
                :cpntStatusImprimir='false'
                :cpntReiniciar="() => {}"
                :cpntOcultarValor="[ 'ie', 'im', 'email', 'rep_cpf', 'rep_nas' ]"
                :data-time="time"
              ></RF-Visualizar-Dados-Cadastro>

              <!-- MONTA A TABELA DE USUARIOS -->
              <App-Tabela v-if="[ '', null, undefined ].indexOf(cpntCadastro.usuario) === -1"
              :cpntColuna="colunas"
              :cpntLinha="cpntCadastro.usuario"
              ref="tabela">
              <template slot="titulo">
                <div class="cfg-contador-cadastro-titulo-tab">
                  <svg aria-hidden="true" class="fa fa-angle-double-right"></svg> Usuários do Contador
                  <!-- Usuários da Licença de Uso {{ cpntCadastro.contador.clu }} -->
                </div>
              </template>

              <template v-slot:col_email="{ valor }">
                <span v-html="valor.split(';').join('<br/>')"></span>
              </template>

              <template v-slot:col_acoes="{ linha }">
                <template v-if="$store.state.token.dep_plus === false || ($store.state.token.dep_plus === true && $store.state.token.clu_mu === 'a')">
                  <RF-Button v-if="[ '', null, undefined ].indexOf(linha.id_usu_vinculado) !== -1"
                  :cpntId='campos.liberar.id'
                  :cpntStatus='campos.liberar.status' 
                  :cpntTexto='campos.liberar.texto'
                  :cpntTipo='campos.liberar.tipo'
                  :cpntIcone='campos.liberar.icone'
                  :cpntClass='campos.liberar.class'
                  @onClickButton='() => { campos.liberar.onClick(cpntCadastro.contador.clu, linha.id_usu) }'>
                  </RF-Button>

                  <RF-Button v-else-if="$store.state.token.dep_plus === false || ($store.state.token.dep_plus === true && $store.state.token.con_clu_iu !== (cpntCadastro.contador.clu + '.' + linha.id_usu))"
                  :cpntId='campos.editar.id'
                  :cpntStatus='campos.editar.status' 
                  :cpntTexto='campos.editar.texto'
                  :cpntTipo='campos.editar.tipo'
                  :cpntIcone='campos.editar.icone'
                  :cpntClass='campos.editar.class'
                  @onClickButton='() => { campos.editar.onClick(linha.id_usu_vinculado) }'>
                  </RF-Button>
                </template>
              </template>
              </App-Tabela>
            </td>
          </tr>

          <!-- SETA O BOTÃO PARA EXCLUIR O CONTADOR -->
          <tr class="botao">
            <td>
              <template v-if="$store.state.token.dep_plus === false">
                <RF-Button v-if="[ '', null, undefined ].indexOf(cpntCadastro.usuario) === -1"
                  :cpntId='campos.excluir.id'
                  :cpntStatus='campos.excluir.status' 
                  :cpntTexto='campos.excluir.texto'
                  :cpntTipo='campos.excluir.tipo'
                  :cpntIcone='campos.excluir.icone'
                  :cpntClass='campos.excluir.class'
                  @onClickButton='() => { campos.excluir.onClick() }'>
                </RF-Button>

                <RF-Button v-else
                  :cpntId='campos.vincular.id'
                  :cpntStatus='campos.vincular.status' 
                  :cpntTexto='campos.vincular.texto'
                  :cpntTipo='campos.vincular.tipo'
                  :cpntIcone='campos.vincular.icone'
                  :cpntClass='campos.vincular.class'
                  @onClickButton='() => { campos.vincular.onClick() }'>
                </RF-Button>
              </template>
            </td>
          </tr>
        </template>

        <tr v-else>
          <td class="vincular">
            Para vincular sua licença de uso à contabilidade solicite ao seu Contador, o código Rotina Fácil dele.
            <br/>
            <br/>
            Após criado o vinculo seu Contador poderá: Visualizar a validade do seu Certificado Digital, baixar as notas emitidas no mês anterior além de todas as permissões que você conceder ao usuário do Contador.
            <br/>
            <br/>
            Você poderá posteriormente editar as permissões do usuário do Contador além de poder desvinculá-lo a qualquer momento.
            <br/>
            <br/>
            <br/>

            <div>
              <App-Input :data-time="time"
              :cpntStatus='campos.vincular_clu.status'
              :cpntId='campos.vincular_clu.id'
              :cpntTabIndex='campos.vincular_clu.tabIndex'
              :cpntNome='campos.vincular_clu.nome'
              :cpntValue='campos.vincular_clu.value'
              :cpntMensagem='campos.vincular_clu.mensagem'
              :cpntMensagemTipo='campos.vincular_clu.mensagemTipo'
              :cpntDisabled='campos.vincular_clu.disabled'
              :cpntMostrar='campos.vincular_clu.mostrar'
              :cpntExplica='campos.vincular_clu.explica'
              :cpntPlaceholder='campos.vincular_clu.placeholder'
              :cpntValueRef='campos.vincular_clu.valueRef'
              :cpntRouter='campos.vincular_clu.router'
              :cpntMethod='campos.vincular_clu.method'
              :cpntField='campos.vincular_clu.field'
              :cpntWhere='campos.vincular_clu.where'
              :cpntAddButForm='campos.vincular_clu.addButForm'
              :cpntKeyMostra='campos.vincular_clu.keyMostra'
              :cpntTipoOrder='campos.vincular_clu.tipoOrder'
              :cpntOrder='campos.vincular_clu.order'
              :cpntOptions='campos.vincular_clu.options'
              :cpntKeyValue='campos.vincular_clu.keyValue'
              :cpntSearchMinimo='campos.vincular_clu.searchMinimo'
              :cpntMask='campos.vincular_clu.mask'
              :cpntOnChange='campos.vincular_clu.onChange'
              :cpntOnBlur='campos.vincular_clu.onBlur'
              :cpntOnRealizaBusca='campos.vincular_clu.onRealizaBusca'
              :cpntOnKeyPressEnter='campos.vincular_clu.onKeyPressEnter'
              ref="vincular_clu"
              ></App-Input>

              <RF-Button
              :cpntId='campos.buscar.id'
              :cpntStatus='campos.buscar.status' 
              :cpntTexto='campos.buscar.texto'
              :cpntTipo='campos.buscar.tipo'
              :cpntIcone='campos.buscar.icone'
              :cpntClass='campos.buscar.class'
              @onClickButton='() => { campos.buscar.onClick() }'>
              </RF-Button>
            </div>

            <hr/>

            <div class="links">
              <a :data-time="time" v-html="campos.novo_cadastro.texto" @click='() => { campos.novo_cadastro.onClick() }'></a>
            </div>
          </td>
        </tr>
      </table>
    </div>

    <!-- SETA A PAGINA PARA CRIAR UM NOVO ACESSO AO CONTADOR -->
    <App-Contador-Config-Novo-Cadastro :data-time="time" v-if="campos.novo_cadastro.dialog === true" :cpntFecharFormulario="campos.novo_cadastro.onClick"></App-Contador-Config-Novo-Cadastro>
  </div>
</template>

<style scoped>
.cfg-contador-cadastro {
  vertical-align: top;
  width: 600px;
}
  .cfg-contador-cadastro > table {
    position: relative;
    width: 100%;
    border-collapse: separate;
  }
    .cfg-contador-cadastro > table > tr > td {
      vertical-align: top;
      padding: 5px;
    }
    .cfg-contador-cadastro > table > tr > td.cadastro {     
      /* display: inline-block; */
      background: #f9f9f9;
      border: 1px solid #ccc;
      padding: 5px 0px;
      border-radius: 5px;
    }
    .cfg-contador-cadastro > table > tr > td.cadastro > .cpnt-tabela {
      width: calc(100% - 20px);
      margin: 10px;
    }
    
    .cfg-contador-cadastro > table > tr.botao > td {
      text-align: center;
      padding: 10px;
    }
    .cfg-contador-cadastro > table > tr.botao > td > button {
      margin: 10px;
      width: 140px;
    }
    .cfg-contador-cadastro > table > tr > td.confirma {
      display: inline-block;
      /* width: 100%; */
    }
  .cfg-contador-cadastro-titulo-tab {
    text-align: left;
    padding: 5px;
    font-weight: bold;
  }

  .cfg-contador-cadastro > table > tr > td.vincular {
    text-align: justify;
  }
    .cfg-contador-cadastro > table > tr > td.vincular > div {
      text-align: center;
    }
      .cfg-contador-cadastro > table > tr > td.vincular > div > .cpnt-app-input {
        width: 200px;
      }
      .cfg-contador-cadastro > table > tr > td.vincular > div > button {
        margin-left: 15px;
      }

  .cfg-contador-cadastro > table > tr > td.vincular > hr {
    margin: 10px;
  }
  .cfg-contador-cadastro > table > tr > td.vincular > div.links {
    text-align: center;
  }
    .cfg-contador-cadastro > table > tr > td.vincular > div.links > a {
      font-size: 12px;
      cursor: pointer;
    }
</style>

<style>
  .cfg-contador-cadastro > table > tr > td.cadastro > table {
    margin: 0px
  }

  .cfg-contador-cadastro > table > tr > td.cadastro > .cpnt-tabela > tbody > tr > td.col_acoes > div > span > button {
    width: 90px;
    margin: 5px;
  }
</style>

<script>
  export default {
    props: {
      cpntCadastro: {
        required: true,
        type: Object
      }
    },
    components: {
      'RF-Visualizar-Dados-Cadastro': () => import('@/components/rf-geral/visualizar/Visualizar-Dados-Cadastro.vue'),
      'App-Contador-Config-Novo-Cadastro': () => import('@/components/contador/config/Contador-Config-Novo-Cadastro.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: '',
        campos: {
          excluir: {
            status: '',
            tipo: 'texto',
            texto: 'Excluir Contador',
            class: 'btn btn-sm btn-danger',
            mostrar: true,
            onClick: this.cfgContadorCadastroExcluirContador
          },
          vincular: {
            status: '',
            tipo: 'texto',
            texto: 'Vincular Contador',
            class: 'btn btn-sm btn-primary',
            mostrar: true,
            onClick: () => { this.cfgContadorCadastroVincularContador() }
          },
          vincular_clu: {
            id: 'cfg-contador-cadastro--vincular_clu',
            status: '',
            nome: 'Código Licença de Uso (CLU)',
            value: '',
            onChange: this.cfgContadorCadastroOnChangeValue,
            onKeyPressEnter: this.demEdiProFormOnKeyPressEnter
          },
          buscar: {
            status: '',
            tipo: 'texto',
            texto: 'Buscar Contador',
            class: 'btn btn-sm btn-primary',
            mostrar: true,
            onClick: this.cfgContadorCadastroBuscarContador
          },
          novo_cadastro: {
            status: '',
            tipo: 'texto',
            texto: 'Não encontrou seu contador? Cadastrar agora.',
            class: 'btn btn-sm btn-primary',
            mostrar: true,
            dialog: false,
            onClick: (atualizar, clu) => {
              // ABRE OU FECHA A DIALOG
              this.campos.novo_cadastro.dialog = !this.campos.novo_cadastro.dialog

              // EXECUTA A FUNÇÃO PARA ATUALIZAR A PAGINA QUANDO NECESSARIO
              if (atualizar === true) {
                this.cfgContadorCadastroVincularContador(clu)
              }
            }
          },
          liberar: {
            status: '',
            tipo: 'texto',
            texto: 'Liberar',
            class: 'btn btn-sm btn-primary',
            mostrar: true,
            onClick: this.cfgContadorCadastroLiberarContador
          },
          editar: {
            status: '',
            tipo: 'texto',
            texto: 'Editar',
            class: 'btn btn-sm btn-warning',
            mostrar: true,
            onClick: this.cfgContadorCadastroEditarUsuario
          }
        },
        colunas: [
          { mPer: 2,    chave: 'id_usu',      nome: 'Cód.'      },
          { mPer: 2,    chave: 'usuario',     nome: 'Usuário'   },
          { mPer: 2,    chave: 'nome',        nome: 'Nome'      },
          { mPer: 2,    chave: 'email',       nome: 'E-mail'    },
          { mPer: 2,    chave: 'acoes',       nome: 'Acesso'    },
        ]
      }
    },
    mounted: function () {
    },
    methods: {
      cfgContadorCadastroSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      cfgContadorCadastroExcluirContador: function () {
        if (confirm('Deseja realmente desvincular este contador?')) {
          // SETA O STATUS DO BOTÃO
          this.campos.excluir.status = 'carregando'

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // INICIA O FORMULARIO QUE SERÁ ENVIADO
          var formData = { clu_contador: this.cpntCadastro.contador.clu }
  
          // FAZ A COMUNICAÇÃO COM A API
          this.$store.state.comunicaAPI('/config/contador', 'DELETE', formData, (retorno) => {
            // APRESENTA A MENSAGEM RECEBIDA
            this.$store.state.TRATAR_RET_LOT_API(retorno)
  
            // MANDA ATUALIZAR A TELA
            this.$emit('ATUALIZAR')
          }, this.cfgContadorCadastroSetarStatusGeral)
        }
      },
      cfgContadorCadastroOnChangeValue: function (value, id) {
        // PEGA O NOME DO CAMPO QUE ESTA SENDO ALTERADO
        var index = id.split('--')[1]

        // SETA O VALOR RECEBIDO
        if ([ 'string', 'number' ].indexOf(typeof value) !== -1) {
          this.campos[index].value = value
        }

        // REMOVE A MENSAGEM DE ERRO
        this.campos[index].mensagem = ''
        this.campos[index].mensagemTipo = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      cfgContadorCadastroBuscarContador: function () {
        // SETA O STATUS DO BOTÃO
        this.campos.buscar.status = 'carregando'

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // PEGA O NUMERO DA CLU DIGITADA
        var clu = this.campos.vincular_clu.value

        // DEIXA APENAS OS NUMEROS RECEBIDOS
        clu = clu.replace(/([^\d])+/gim, '')

        // SETA A FUNÇÃO PARA EXECUTAR
        var finalizar = () => {
          // SETA O STATUS DO BOTÃO
          this.campos.buscar.status = ''

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        }

        // VALIDA A INFORMAÇÃO RECEBIDA
        if (clu.length !== 4 || isNaN(clu) === true) {
          // APRESENTA A MENSAGEM AO CLIENTE
          this.$store.state.msgWarn('WEB [406]: Informe a CLU com 4 digitos numéricos.', 'warning')

          // EXECUTA A FUNÇÃO SOLICITADA
          finalizar()
        } else {  
          this.$store.state.comunicaAPI('/config/contador/buscar/get/' + clu, 'GET', null, (retorno) => {
            // MANDA ATUALIZAR A TELA
            this.$emit('SETAR_DADOS_NOVO_CONTADOR', { contador: retorno.data })
            
            // EXECUTA A FUNÇÃO SOLICITADA
            finalizar()
          }, (apiError) => {
            // SETA O STATUS DA PAGINA
            this.cfgContadorCadastroSetarStatusGeral(apiError)

            // EXECUTA A FUNÇÃO SOLICITADA
            finalizar()
          })
        }
      },
      cfgContadorCadastroEditarUsuario: function (id_usu) {
        this.$store.state.OPEN_PAGE_CS(process.env.VUE_APP_URL_CS + '/app/usuarios/usuarios.php?cts=' + this.$store.state.token.cts + '&editar=' + id_usu, '_self')
      },
      cfgContadorCadastroLiberarContador: function (clu, id_usu) {
        if (confirm('Este processo LIBERA o acesso com as permissões padrões para o seu Contador. Você será redirecionado para a tela de Editar as permissões do Usuário do Contador.\n\nDeseja continuar?')) {
          // INICIA O FORMULARIO QUE SERÁ ENVIADO
          var formData = {
            clu_contador: clu,
            id_usu_contador: id_usu
          }

          // FAZ A COMUNICAÇÃO COM A API
          this.$store.state.comunicaAPI('/config/contador/usuario', 'POST', formData, (retorno) => {
            // APRESENTA A MENSAGEM RECEBIDA
            this.$store.state.TRATAR_RET_LOT_API(retorno)

            // SETA A PAGINA QUE DEVE REDIRECIONAR
            this.cfgContadorCadastroEditarUsuario(retorno.ref.id_usu_contador)
          }, this.cfgContadorCadastroSetarStatusGeral)
        }
      },
      cfgContadorCadastroVincularContador: function (clu = '') {
        if (clu !== '' || (clu === '' && confirm('Atenção:\n\nApós criado o vinculo seu Contador poderá: Visualizar a validade do seu Certificado Digital, baixar as notas emitidas no mês anterior além de todas as permissões que você conceder ao usuário do Contador.\n\nVocê poderá posteriormente editar as permissões do usuário do Contador além de poder desvinculá-lo a qualquer momento.\n\nDeseja continuar?'))) {
          // INICIA O FORMULARIO QUE SERÁ ENVIADO
          var formData = { clu_contador: (clu !== '' ? clu : this.cpntCadastro.contador.clu) }

          // FAZ A COMUNICAÇÃO COM A API
          this.$store.state.comunicaAPI('/config/contador', 'POST', formData, (retorno) => {
            // APRESENTA A MENSAGEM RECEBIDA
            this.$store.state.TRATAR_RET_LOT_API(retorno)
  
            // MANDA ATUALIZAR A TELA
            this.$emit('ATUALIZAR')
          }, this.cfgContadorCadastroSetarStatusGeral)
        }
      },
    }
  }
</script>
